import { GuardedComponent } from '../components/guarded-component';
import EditProjectBuilding from '../features/projects/edit-project/edit-project-building/edit-project-building';
import { UnitDetailsPage } from '../features/units/unit-details/unit-details.page';
import { UnitProfilePage } from '../features/units/unit-profile/unit-profile-page';
import { UnitsPage } from '../features/units/units.page';
import { UserPermissionName } from '../models/user-permission-name';

export const UnitsRoute = {
  path: '/units',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_UNIT]} showPermissionError>
          <UnitsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'edit/:unitID',
      name: 'edit',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_UNIT]} showPermissionError>
          <UnitDetailsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'details/:unitID',
      name: 'details',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_UNIT]} showPermissionError>
          <UnitDetailsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'profile/:unitID',
      name: 'Profile',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_UNIT]} showPermissionError>
          <UnitProfilePage />
        </GuardedComponent>
      ),
    },
    {
      path: 'addLotOrUnit',
      name: 'Add Lot/unit',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_UNIT]} showPermissionError>
          <EditProjectBuilding />
        </GuardedComponent>
      ),
    },
  ],
};
